import { Component, Optional } from '@angular/core';
import { ConceptService } from "./concept.service";
import { MatDialogRef } from '@angular/material/dialog';
import { ConceptModel } from './concept.model';
import { ConceptImportConst } from '../const';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';

@Component({
    selector: 'convfact-concept-import',
    templateUrl: './concept-import.component.html',
    styleUrls: ['./concept-import.component.css'],
    standalone: false
})
export class ConceptImportComponent {

  headerTable: any[] = ConceptImportConst.headerTable;
  dataReady = false;
  working = false;
  imported = false;
  dragOver = false;
  dataSource: ConceptModel[] = [];
  selectedFileName: string = '';
  errorMessage: string = '';
  importedCount: number = 0;
  private hasImportedAny = false;
  loadingMessage: string = 'Procesando el archivo…';

  constructor(
    private conceptService: ConceptService,
    private notification: NotificationService,
    @Optional() public dialogRef: MatDialogRef<ConceptImportComponent, boolean>
  ) { }

  downloadTemplate(): void {
    window.open('/assets/templates/plantilla_conceptos.xlsx', '_blank');
  }

  downloadDemoTemplate(): void {
    window.open('/assets/templates/plantilla_conceptos_demo.xlsx', '_blank');
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.dragOver = true;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragOver = false;
    const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
    if (file) this.upload(file);
  }

  fileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';
    if (file) this.upload(file);
  }

  reset(): void {
    this.dataReady = false;
    this.imported = false;
    this.dataSource = [];
    this.selectedFileName = '';
    this.errorMessage = '';
    this.importedCount = 0;
  }

  addConcepts(): void {
    if (this.working || this.dataSource.length === 0) return;

    this.errorMessage = '';
    this.startWork('Añadiendo conceptos…');

    this.conceptService.importData(this.dataSource)
      .then(() => {
        this.importedCount = this.dataSource.length;
        this.imported = true;
        this.hasImportedAny = true;
        this.dataReady = false;
        this.notification.ok('Conceptos añadidos correctamente');
      })
      .catch(error => {
        this.errorMessage = this.extractError(error) || 'No se pudieron añadir los conceptos.';
      })
      .then(() => this.endWork());
  }

  closeDialog(): void {
    if (this.working) return;
    if (this.dialogRef) this.dialogRef.close(this.hasImportedAny);
  }

  private upload(file: File): void {
    if (this.working) return;

    if (!/\.xlsx$/i.test(file.name)) {
      this.errorMessage = 'El archivo debe ser un Excel (.xlsx) con el formato de la plantilla.';
      return;
    }

    const formData = new FormData();
    formData.append('file', file, file.name);

    this.selectedFileName = file.name;
    this.errorMessage = '';
    this.startWork('Procesando ' + file.name + '…');

    this.conceptService.conceptsImport(formData)
      .then(response => {
        this.dataSource = response || [];
        this.dataReady = true;

        if (this.dataSource.length === 0) {
          this.dataReady = false;
          this.errorMessage = 'El archivo no contiene conceptos. Revisa que tenga el formato de la plantilla.';
        }
      })
      .catch(error => {
        this.dataReady = false;
        this.dataSource = [];
        this.errorMessage = this.extractError(error)
          || 'No se pudo leer el archivo. Revisa que tenga el formato de la plantilla.';
      })
      .then(() => this.endWork());
  }

  private startWork(message: string): void {
    this.loadingMessage = message;
    this.working = true;
    if (this.dialogRef) this.dialogRef.disableClose = true;
  }

  private endWork(): void {
    this.working = false;
    if (this.dialogRef) this.dialogRef.disableClose = false;
  }

  private extractError(error: any): string {
    if (!error) return '';
    if (typeof error === 'string') return error;
    if (error.error && error.error.message) return error.error.message;
    return error.message || '';
  }
}
